//https://echarts.apache.org/zh/option.html
// 辖区风险指数雷达图
export const radarOption = {
	//柱形图和折线图相互切换
	toolbox: {
		show: true,
		feature: {
			myTool1: {
				show: true,
				title: "切换成柱状体",
				icon:
					"path://M96 416h832c0.32 0 0.576-0.192 0.896-0.192a30.656 30.656 0 0 0 30.976-30.976c-0.064-0.256 0.128-0.512 0.128-0.832a31.424 31.424 0 0 0-14.912-26.368l-188.48-188.48a30.72 30.72 0 1 0-43.456 43.456L852.544 352H96a32 32 0 0 0 0 64z m832 192H96c-0.32 0-0.576 0.192-0.896 0.192a30.528 30.528 0 0 0-30.976 30.976c0.064 0.256-0.128 0.512-0.128 0.832 0 11.264 6.144 20.672 14.912 26.368l188.48 188.48a30.72 30.72 0 1 0 43.456-43.456L171.456 672H928a32 32 0 0 0 0-64z",
				onclick: function () {
					// console.log('111');
					// radarOption.series.type='bar'
				},
			},

			//     /* line是折线图，bar是柱形图*/
			//    show:true,
			// magicType: { show: true, type: ["bar"] },


		},
		top: '20%'
	},
	color: ["rgba(237, 171, 70, 1)", "#67F9D8", "#FFE434", "#56A3F1", "#FF917C"],
	title: {
		text: "",
	},
	legend: {
		show: true,
		itemStyle: {},
		textStyle: { color: "#fff" },
		left: 'right',
		orient: "vertical",
	},
	tooltip: {
		show: true,
		trigger: "item",
		confine: true,
		axisPointer: {
			snap: true,
			label: {
				// overflow:'breakAll'
			}
		},
		padding: 15,
		// formatter: "{value}",
		// appendToBody: true,
	},
	// backgroundColor: "#666",

	radar: {
		indicator: [],
		center: ["50%", "50%"],
		radius: 80,
		startAngle: 90,
		splitNumber: 3,
		shape: "circle",
		name: {
			show: true,
			data: "{value}\n",
			formatter: "{value}\n",
			color: "#fff",
		},
		splitArea: {
			areaStyle: {
				color: ["#596481", "#515e81", "#495981"],
				shadowColor: "rgba(0, 0, 0, 0.2)",
				shadowBlur: 10,
			},
		},
		axisLine: {
			show: false,
			lineStyle: {
				color: "#fff",
			},
		},
		splitLine: {
			show: false,
			lineStyle: {
				color: "rgba(211, 253, 250, 0.8)",
			},
		},
	},
	// xAxis: {
	// 	type: 'category',
	// 	data: []
	//   },
	series: {

		type: "radar",
		// legendHoverLink:false,
		emphasis: {
			lineStyle: {
				width: 4,
			},
		},
		label: {
			formatter: "{value}",

		},
		data: [
			// {
			// 	value: [100, 8, 0.4, -80, 2000],
			// 	name: "Data A",
			// 	areaStyle: {
			// 		color: "#3289d5",
			// 	},
			// },
			{
				value: [],
				name: "评估分数",
				areaStyle: {
					color: "rgba(237, 171, 70, 1)",
				},
			},
		],
	},
};
// 辖区风险指数放射图
export const radiateOption = {

	toolbox: {
		show: true,
		feature: {
			myTool1: {
				show: true,
				title: "切换成柱状体",
				icon:
					"path://M96 416h832c0.32 0 0.576-0.192 0.896-0.192a30.656 30.656 0 0 0 30.976-30.976c-0.064-0.256 0.128-0.512 0.128-0.832a31.424 31.424 0 0 0-14.912-26.368l-188.48-188.48a30.72 30.72 0 1 0-43.456 43.456L852.544 352H96a32 32 0 0 0 0 64z m832 192H96c-0.32 0-0.576 0.192-0.896 0.192a30.528 30.528 0 0 0-30.976 30.976c0.064 0.256-0.128 0.512-0.128 0.832 0 11.264 6.144 20.672 14.912 26.368l188.48 188.48a30.72 30.72 0 1 0 43.456-43.456L171.456 672H928a32 32 0 0 0 0-64z",
				onclick: function () {
					// console.log('111');
					// radarOption.series.type='bar'
				},
			},

			//     /* line是折线图，bar是柱形图*/
			//    show:true,
			// magicType: { show: true, type: ["bar"] },


		},
		top: '20%'
	},
	color: ["rgba(237, 171, 70, 1)", "#67F9D8", "#FFE434", "#56A3F1", "#FF917C"],
	angleAxis: {
		type: 'category',
		data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
		axisLabel: {
			color: '#fff'
		},


	},
	tooltip: {
		show: true,
		trigger: "item",
		confine: true,
		axisPointer: {
			snap: true,
			label: {
				// overflow:'breakAll'
			}
		},
		padding: 15,
		// formatter: "{value}",
		// appendToBody: true,
	},
	legend: {
		show: true,
		itemStyle: {},
		textStyle: { color: "#fff" },
		left: 'right',
		orient: "vertical",
	},
	radiusAxis: {
		axisLine: {
			lineStyle: {
				color: '#fff'
			}
		}
	},
	polar: {
		radius: ["0%", "77%"],
		center: ["50%", "50%"],
	},
	series: [
		{
			type: 'bar',
			// radius:'80%',
			// center:['50%','50%'],
			data: [],
			coordinateSystem: 'polar',
			name: '评估分数',

		},
	],
};
// 辖区风险指数柱状图
export const radarOption1 = {
	toolbox: {
		show: true,
		feature: {
			myTool1: {
				show: true,
				title: "切换成放射图",
				icon:
					"path://M96 416h832c0.32 0 0.576-0.192 0.896-0.192a30.656 30.656 0 0 0 30.976-30.976c-0.064-0.256 0.128-0.512 0.128-0.832a31.424 31.424 0 0 0-14.912-26.368l-188.48-188.48a30.72 30.72 0 1 0-43.456 43.456L852.544 352H96a32 32 0 0 0 0 64z m832 192H96c-0.32 0-0.576 0.192-0.896 0.192a30.528 30.528 0 0 0-30.976 30.976c0.064 0.256-0.128 0.512-0.128 0.832 0 11.264 6.144 20.672 14.912 26.368l188.48 188.48a30.72 30.72 0 1 0 43.456-43.456L171.456 672H928a32 32 0 0 0 0-64z",
				onclick: function () {

				},
			},


		},
		top: '20%'
	},
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			type: 'shadow'
		},//鼠标移上的阴影，默认是线
		axisPointer: {
			type: "line",
			lineStyle: {
				type: 'solid', // 将虚线改为实线
				width: 26, // 设置背景的宽度
				color: 'rgb(179, 179, 179,0.3)',


			}
		}


	},
	xAxis: {
		type: 'category',
		axisLabel: {
			color: "#DAF4FF",
			interval: 0,
			rotate: 45,
		},
		axisTick: {
			show: false,
		},
		data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
	},
	yAxis: {
		type: 'value',
		axisLabel: {
			color: "#DAF4FF",
			interval: 0,
		},
		axisTick: {
			show: false,
		},
	},
	series: [
		{
			name: '风险分数',
			type: 'bar',
			barGap: '60%',
			barWidth: 20,
			itemStyle: {

				// color: 'rgba(255,164,41,.16)',
				color: {
					x: 0,
					y: 0,
					x2: 0,
					y2: 1,
					type: 'linear',
					global: false,
					colorStops: [
						{
							//第一节下面
							offset: 0,
							color: 'rgba(63, 250, 250, 0.9)',
						},
						{
							offset: 1,
							color: 'rgba(22, 148, 255, 0.1)',
						},
					],
				},
				borderColor: {
					x: 0,
					y: 0,
					x2: 0,
					y2: 1,
					type: 'linear',
					global: false,
					colorStops: [
						{
							//第一节下面
							offset: 0,
							color: 'rgba(63, 250, 250, 0.9)',
						},
						{
							offset: 1,
							color: 'rgba(22, 148, 255, 0.1)',
						},
					],
				},
				borderWidth: 1,
				borderType: 'solid',
			},
			// label: {
			//     show: true,
			//     formatter: '{c}' + '%',
			//     position: 'top',
			//     color: 'rgba(255,228,59,1)',
			//     fontSize: 12,
			//     textAlign: 'center',
			// },
			zlevel: 2,
			data: [],
		},
		// {
		// 	name: '浅黄柱子',
		// 	data: [],
		// 	type: 'bar',
		// 	barGap: '60%',
		// 	zlevel: 1,
		// 	itemStyle: {
		// 		normal: {
		// 			color: 'rgba(22, 148, 255, 0.1)',
		// 		},
		// 	},
		// },
		// {
		// 	name: '黄色底座',
		// 	type: 'pictorialBar',
		// 	symbolSize: [30, 10],
		// 	symbolOffset: ['-81%', 5],
		// 	z: 12,
		// 	color: 'rgba(22, 148, 255)',
		// },

	]

};
// 设备在线统计
export const scaleRingOption = {
	polar: {
		radius: ["61%", "57%"],
		center: ["50%", "50%"],
	},
	title: {
		zlevel: 0,
		text: 20,
		subtext: "总计设备数",
		top: "40%",
		// left: "49%",
		// textAlign: "center",
		right: "center",
		textStyle: {
			color: "rgba(218, 244, 255, 1)",
			fontSize: 26,
			fontWeight: 700,
		},
		subtextStyle: {
			fontSize: 12,
			color: "#fff",
		},
	},
	graphic: [
		{
			type: "image",
			id: "background",
			right: "center", // 根据父元素进行定位 （居中） center
			// left: "25%", // 根据父元素进行定位 （居中）
			// top: "25%", // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
			bottom: "center", // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
			z: 0, // 层叠
			bounding: "all", // 决定此图形元素在定位时，对自身的包围盒计算方式
			style: {
				image: require("@/assets/img/analysis/scale-ring-background.png"), // 这里一定要注意、注意，必须是https开头的图片路径地址
				width: 120,
				height: 120,
			},
		},
	],
	angleAxis: {
		max: 1,
		show: false,
		startAngle: 0,
	},
	radiusAxis: {
		type: "category",
		show: true,
		axisLabel: { show: false },
		axisLine: { show: false },
		axisTick: { show: false },
	},
	series: [
		// 外层刻度
		{
			hoverAnimation: false,
			type: "pie",
			z: 1,
			data: [],
			radius: ["95%", "75%"],
			zlevel: -1,
			label: {
				normal: {
					position: "inside",
					show: false,
				},
			},
		},
	],
};
let category = [
	{
		name: "美育教育1",
		value: 1000,
	},
	{
		name: "劳动教育2",
		value: 2000,
	},
	{
		name: "生活技能3",
		value: 3000,
	},
	{
		name: "日常起居4",
		value: 4000,
	},
	{
		name: "劳动教育5",
		value: 5000,
	},
	{
		name: "生活技能6",
		value: 6000,
	},
	{
		name: "日常起居7",
		value: 7000,
	},
	{
		name: "劳动教育8",
		value: 8000,
	},
	{
		name: "生活技能9",
		value: 9000,
	},
];
let yName = []; // y轴名称
let bgData = []; // 最大值用作背景显示的数据
let maxValue = category[category.length - 1].value; //最大值
let hhhh = [],
	righty = [];
category.forEach((element) => {
	righty.push(element.value);
	yName.push(element.name);
	hhhh.push(element.name);
});
// 报警单位
export const batteryBarOoption = {
	backgroundColor: "#fff0",
	dataZoom: [
		{
			show: true,
			yAxisIndex: [0, 1],
			// realtime: true,
			// start: 0,
			right: "0%",
			width: 8,
			// height: 10, // 组件高度
			showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
			// end: 35,
			start: 100,
			startValue: 0,
			endValue: 7,
			minSpan: 4, //用于限制窗口大小的最小值（实际数值）。
			// maxSpan: 10,
			brushSelect: false, // 是否开启刷选功能
			orient: "vertical",
			backgroundColor: "transparent",
			showDataShadow: false,
			fillerColor: "rgba(64, 83, 133, 0.8)",
			// borderColor: 'transparent',
			handleSize: 0,
			throttle: 100,
		},
		{
			type: "inside", // 支持内部鼠标滚动平移

			orient: "vertical",
			zoomOnMouseWheel: false, // 关闭滚轮缩放
			moveOnMouseWheel: true, // 开启滚轮平移
			moveOnMouseMove: true, // 鼠标移动能触发数据窗口平移
		},
	],
	xAxis: {
		max: 3000,
		splitLine: {
			show: false,
		},
		axisLine: {
			show: false,
		},
		axisLabel: {
			show: false,
		},
		axisTick: {
			show: false,
		},
	},
	grid: {
		left: 120,
		top: 0,
		right: 80,
		bottom: 10,
		// containLabel: true,
		offset: 50,
	},
	yAxis: [
		{
			// y轴最左侧的文字
			axisTick: "none",
			axisLine: "none",
			inside: true,
			position: "left",
			type: "category",
			axisLabel: {
				padding: [12, 12, 13, 10], // 调整文字位置
				textStyle: {
					color: "#fff",
					fontSize: "12",
					fontWeight: "400",
				},

				formatter: (params, index) => {
					var newParamsName = "";
					var paramsNameNumber = params.length;
					var provideNumber = 7; //一行显示几个字
					var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
					if (paramsNameNumber > provideNumber) {
						//两行展示
						for (var p = 0; p < 2; p++) {
							var tempStr = "";
							var start = p * provideNumber;
							var end = start + provideNumber;
							if (p == rowNumber - 1) {
								tempStr = params.substring(start, paramsNameNumber);
							} else {
								tempStr = params.substring(start, end) + "\n";
							}
							newParamsName += tempStr;
						}
						//换行时....
						if (paramsNameNumber > 2 * provideNumber)
							newParamsName = newParamsName.substring(0, newParamsName.length - 2) + "..." + " ";
					} else {
						newParamsName = params;
					}
					//调取生成浮窗的函数
					// that.extension(that.chart);
					return newParamsName;
				},
			},
			data: [],
		},
		{
			// y轴最右侧的文字
			axisTick: "none",
			axisLine: "none",
			type: "category",
			axisLabel: {
				margin: 14,
				textStyle: {
					color: "#2CE4FF",
					fontSize: "18",
				},
				formatter: (value, index) => {
					return value + "个";
				},
			},
			data: [],
		},
	],
	series: [
		{
			name: "info",
			// 内（显示的内容）
			type: "bar",
			barGap: "-100%",
			barWidth: 18,
			legendHoverLink: false,
			silent: true,
			itemStyle: {
				normal: {
					color: function (params) {
						// console.log(params.dataIndex);
						var color;
						if (params.dataIndex % 2 != 0) {
							color = {
								type: "linear",
								x: 0,
								y: 0,
								x2: 1,
								y2: 0,
								colorStops: [
									{
										offset: 0,
										color: "#93F6FF", // 0% 处的颜色
									},
									{
										offset: 1,
										color: "#48FFF4", // 100% 处的颜色
									},
								],
							};
						} else {
							color = {
								type: "linear",
								x: 0,
								y: 0,
								x2: 1,
								y2: 0,
								colorStops: [
									{
										offset: 0,
										color: "#93F6FF", // 0% 处的颜色
									},
									{
										offset: 1,
										color: "#48FFF4", // 100% 处的颜色
									},
								],
							};
						}
						return color;
					},
				},
			},
			data: [],
			z: 1,
			animationEasing: "elasticOut",
		},
		{
			// 分隔
			type: "pictorialBar",
			itemStyle: {
				normal: {
					color: "#000",
				},
			},
			symbolRepeat: "fixed",
			symbolMargin: 4,
			symbol: "rect",
			symbolClip: true,
			symbolSize: [2, 18],
			symbolPosition: "start",
			symbolOffset: [0, 0],
			symbolBoundingData: 0,
			// data: bgData,
			data: [],
			animation: false, //关闭动画
			z: 2,
			animationEasing: "elasticOut",
		},
	],
};
// 单位安全等级分布漏斗图
export const funnelOption = {
	color: ["#D43030", "#FF8D1A", "#FFEB3B", "#1AABFF", "#1D9E56"],
	title: {
		// text: "基础漏斗图",
		textStyle: {
			color: "red",
			fontWeight: "bold",
		},
		left: "25%",
		top: "-5%",
		subtext: "当前安全等级分布",
		subtextStyle: {
			color: "#FFFFFF",
			fontStyle: "italic",
		},
		x: "center",
	},
	legend: {
		show: false,
		left: "left",
		top: "2%",
		orient: "vertical",
		textStyle: { color: "#fff" },
	},
	series: [
		{
			type: "funnel",
			width: "50%",
			height: "76%",
			top: "center",
			left: "30%",
			sort: "none",
			min: 0,
			// max: 1,
			label: {
				normal: {
					position: "right",
					// formatter: "{b}: {c}({d}%)",
					formatter: "{d}%",
					color: "",
					fontSize: 24,
					left: 20,
				},
				// emphasis: {
				// 	formatter: "{b}: {c}({d}%)",
				// },
			},
			// funnelAlign: 'center',  // 漏斗对齐方向
			data: [],
		},

	],
};
// 单位安全等级正负条形图
export const unitSafetyOption = {
	tooltip: {
		show: true,
		trigger: "item",
		confine: true,
		axisPointer: {
			snap: true,
			label: {
				// overflow:'breakAll'
			}
		},
		padding: 15,
		// formatter: "{value}",
		// appendToBody: true,
	},
	barWidth: 30, //柱子宽度
	barGap: 0.4, //柱子之间间距
	grid: {
		left: '33%',
		right: '4%',
		bottom: '3%',
		height: '90%',
		containLabel: true
	},
	xAxis: [
		{
			type: 'value',
			axisLabel: {
				color: "#DAF4FF",
				interval: 0,
				rotate: 45,
			},
			axisLine: {
				show: false,
				lineStyle: {
					color: "#0a3e98",
				},
			},

		}
	],
	yAxis: [
		{
			type: 'category',
			axisTick: {
				show: false
			},
			data: ['']
		}
	],
	series: [
		{
			name: '5级',
			type: 'bar',
			stack: 'Total',
			color: ["#D43030"],
			data: [200]
		},
		{
			name: '5级',
			type: 'bar',
			stack: 'Total',
			color: ["#D43030"],
			data: [-200]
		},
		{
			name: '4级',
			type: 'bar',
			stack: 'Total1',
			color: "#FF8D1A",

			data: [200]
		},
		{
			name: '4级',
			type: 'bar',
			stack: 'Total1',

			color: "#FF8D1A",
			data: [-120]
		},
		{
			name: '3级',
			type: 'bar',
			stack: 'Total11',
			color: "#FFEB3B",
			data: [200]
		},
		{
			name: '3级',
			type: 'bar',
			stack: 'Total11',
			color: "#FFEB3B",
			data: [-120]
		},
		{
			name: '2级',
			type: 'bar',
			stack: 'Total111',
			color: "#1AABFF",
			data: [200]
		},
		{
			name: '2级',
			type: 'bar',
			stack: 'Total111',
			color: "#1AABFF",
			data: [-120]
		},
		{
			name: '1级',
			type: 'bar',
			stack: 'Total1111',
			color: "#1D9E56",
			data: [200]
		},
		{
			name: '1级',
			type: 'bar',
			stack: 'Total1111',
			color: "#1D9E56",
			data: [-120]
		}

	]
};
// 态势五色图
export const mapOption = {
	// 背景颜色
	// backgroundColor: "#ffffff00",
	backgroundColor: "#ffffff00",
	layoutCenter: ['50%', '50%'],
	layoutSize: '78%',//大小
	aspectScale: 0.90, //宽高比
	graphic: [
		{
			type: "image",
			id: "background",
			right: "center", // 根据父元素进行定位 （居中）
			bottom: "0%", // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
			z: 0, // 层叠
			bounding: "all", // 决定此图形元素在定位时，对自身的包围盒计算方式
			style: {
				image: require("@/assets/img/analysis/map-background.png"), // 这里一定要注意、注意，必须是https开头的图片路径地址
				width: 1200,
				height: 600,
			},
		},
	],
	tooltip: {
		//                    show: false //不显示提示标签
		formatter: "{b}", //提示标签格式
		backgroundColor: "#ff7f50", //提示标签背景颜色
		textStyle: { color: "#fff" }, //提示标签字体颜色
	},

	// 地图配置
	series: [
		{
			center: [120.384428184, 36.1052149013],
			type: "map",
			mapType: "SITQD",
			// radius: ['100%', '50%'],
			// roam: "scale", // 缩放&&平移
			roam: true, // 缩放&&平移
			scaleLimit: {
				min: 0.75,
				max: 18,
			},
			label: {
				// 通常状态下的样式
				normal: {
					show: true,
					textStyle: {
						color: "#02f6ff",
					},
				},
				// 鼠标放上去的样式
				emphasis: {
					textStyle: {
						color: "#02f6ff",
					},
				},
			},
			// 地图区域的样式设置
			itemStyle: {
				normal: {
					borderColor: "#02f6ff",
					borderWidth: 3,
					areaColor: "#02f6ff00",

					shadowColor: "#02f6ff33",
					shadowOffsetX: -2,
					shadowOffsetY: 2,
					shadowBlur: 10,
				},
				// 鼠标放上去高亮的样式
				emphasis: {
					areaColor: "#c8c5c578",
					borderColor: "#fff",
					borderWidth: 3,
				},
			},
			markPoint: {
				// symbol: "pin",
				symbolSize: 30, // 标记大小
				symbolRotate: 0, // 旋转角度
				symbolOffset: [0, 0], // 偏移量
				label: "", // 标记的文本
				data: [],
			},
			data: [
				// { name: "章丘区", selected: false }, //章丘区为选中状态
			],
		},
	],
};
// 用来初始化区域地图
export const mapOption1 = {
	// 背景颜色
	backgroundColor: "#ffffff00",
	layoutCenter: ['50%', '50%'],
	layoutSize: '78%',//大小
	aspectScale: 0.90, //宽高比
	graphic: [
		{
			type: "image",
			id: "background",
			right: "center", // 根据父元素进行定位 （居中）
			bottom: "0%", // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
			z: 0, // 层叠
			bounding: "all", // 决定此图形元素在定位时，对自身的包围盒计算方式
			style: {
				image: require("@/assets/img/analysis/map-background.png"), // 这里一定要注意、注意，必须是https开头的图片路径地址
				width: 1200,
				height: 600,
			},
		},
	],
	tooltip: {
		//                    show: false //不显示提示标签
		formatter: "{b}", //提示标签格式
		backgroundColor: "#ff7f50", //提示标签背景颜色
		textStyle: { color: "#fff" }, //提示标签字体颜色
	},

	// 地图配置
	series: [
		{
			center: [120.384428184, 36.1052149013],
			type: "map",
			mapType: "SITQD",
			roam: true, // 缩放&&平移
			scaleLimit: {
				min: 0.75,
				max: 18,
			},
			label: {
				// 通常状态下的样式
				normal: {
					show: true,
					textStyle: {
						color: "#02f6ff",
					},
				},
				// 鼠标放上去的样式
				emphasis: {
					textStyle: {
						color: "#02f6ff",
					},
				},
			},
			// 地图区域的样式设置
			itemStyle: {
				normal: {
					borderColor: "#02f6ff",
					borderWidth: 3,
					areaColor: "#02f6ff00",

					shadowColor: "#02f6ff33",
					shadowOffsetX: -2,
					shadowOffsetY: 2,
					shadowBlur: 10,
				},
				// 鼠标放上去高亮的样式
				emphasis: {
					areaColor: "#c8c5c578",
					borderColor: "#fff",
					borderWidth: 3,
				},
			},
			markPoint: {
				// symbol: require("@/assets/img/analysis/yellow-icon.png"),
				symbolSize: 30, // 标记大小
				symbolRotate: 0, // 旋转角度
				symbolOffset: [0, 0], // 偏移量
				label: "", // 标记的文本
				data: [],
			},

			data: [],
		},
	],
};
// 济南
export const jinanMapOption = {
	// 背景颜色
	backgroundColor: "#ffffff00",
	layoutCenter: ['50%', '50%'],
	layoutSize: '81%',//大小
	aspectScale: 0.90, //宽高比
	graphic: [
		{
			type: "image",
			id: "background",
			right: "center", // 根据父元素进行定位 （居中）
			bottom: "0%", // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
			z: 0, // 层叠
			bounding: "all", // 决定此图形元素在定位时，对自身的包围盒计算方式
			style: {
				image: require("@/assets/img/analysis/map-background.png"), // 这里一定要注意、注意，必须是https开头的图片路径地址
				width: 1200,
				height: 600,
			}
		},
	],
	tooltip: {
		//                    show: false //不显示提示标签
		formatter: "{b}", //提示标签格式
		backgroundColor: "#ff7f50", //提示标签背景颜色
		textStyle: { color: "#fff" }, //提示标签字体颜色
	},

	// 地图配置
	series: [
		{
			center: [117.024967066, 36.6827847272],
			type: "map",
			mapType: "QD",
			roam: "true", // 缩放&&平移
			radius: ['100%', '50%'],
			scaleLimit: {
				min: 0.75,
				max: 18,
			},
			label: {
				// 通常状态下的样式
				normal: {
					show: true,
					textStyle: {
						color: "#02f6ff",
					},
				},
				// 鼠标放上去的样式
				emphasis: {
					textStyle: {
						color: "#02f6ff",
					},
				},
			},
			// 地图区域的样式设置
			itemStyle: {
				normal: {
					borderColor: "#02f6ff",
					borderWidth: 3,
					areaColor: "#02f6ff00",

					shadowColor: "#02f6ff33",
					shadowOffsetX: -2,
					shadowOffsetY: 2,
					shadowBlur: 10,
				},
				// 鼠标放上去高亮的样式
				emphasis: {
					areaColor: "#c8c5c578",
					borderColor: "#fff",
					borderWidth: 3,
				},
			},
			markPoint: {
				// symbol: "pin",
				symbolSize: 30, // 标记大小
				symbolRotate: 0, // 旋转角度
				symbolOffset: [0, 0], // 偏移量
				label: "", // 标记的文本
				data: [],
			},
			data: [
				// { name: "章丘区", selected: false }, //章丘区为选中状态
			],
		},
	],

};
export const jinanMapOption1 = {
	// 背景颜色
	backgroundColor: "#ffffff00",
	graphic: [
		{
			type: "image",
			id: "background",
			right: "center", // 根据父元素进行定位 （居中）
			bottom: "0%", // 根据父元素进行定位   （0%）, 如果bottom的值是 0，也可以删除该bottom属性值。
			z: 0, // 层叠
			bounding: "all", // 决定此图形元素在定位时，对自身的包围盒计算方式
			style: {
				image: require("@/assets/img/analysis/map-background.png"), // 这里一定要注意、注意，必须是https开头的图片路径地址
				width: 1200,
				height: 600,
			}
		},
	],
	tooltip: {
		//                    show: false //不显示提示标签
		formatter: "{b}", //提示标签格式
		backgroundColor: "#ff7f50", //提示标签背景颜色
		textStyle: { color: "#fff" }, //提示标签字体颜色
	},

	// 地图配置
	series: [
		{
			center: [117.024967066, 36.6827847272],
			type: "map",
			mapType: "QD",
			roam: "scale", // 缩放&&平移
			scaleLimit: {
				min: 0.75,
				max: 18,
			},
			label: {
				// 通常状态下的样式
				normal: {
					show: true,
					textStyle: {
						color: "#02f6ff",
					},
				},
				// 鼠标放上去的样式
				emphasis: {
					textStyle: {
						color: "#02f6ff",
					},
				},
			},
			// 地图区域的样式设置
			itemStyle: {
				normal: {
					borderColor: "#02f6ff",
					borderWidth: 3,
					areaColor: "#02f6ff00",

					shadowColor: "#02f6ff33",
					shadowOffsetX: -2,
					shadowOffsetY: 2,
					shadowBlur: 10,
				},
				// 鼠标放上去高亮的样式
				emphasis: {
					areaColor: "#c8c5c578",
					borderColor: "#fff",
					borderWidth: 3,
				},
			},
			markPoint: {
				symbol: "pin",
				symbolSize: 30, // 标记大小
				symbolRotate: 0, // 旋转角度
				symbolOffset: [0, 0], // 偏移量
				label: "", // 标记的文本
				data: [],
			},
			data: [
				// { name: "章丘区", selected: false }, //章丘区为选中状态
			],
		},
	],

};
// 各区评估维保
export const maintenanceOption = {
	backgroundColor: "",
	tooltip: {
		show: true,
		backgroundColor: "#2D3430",
		// trigger: "item",
		// axisPointer: {
		// 	type: "shadow",
		// },
		// padding: 15,
		// formatter: "{value}",
		confine: true,
		// appendToBody: true,
		trigger: "axis",
		// axisPointer: {
		// 	type: "shadow",
		// },
		// formatter:'{c}%'
	},
	// legend: {
	// 	orient: 'vertical',
	// 	left: '30%'
	//   },
	legend: {
		show: true,
		orient: 'vertical',
		itemWidth: 30,
		itemHeight: 12,
		// top: "10%",
		right: 0,
		textStyle: {
			fontStyle: "normal",
			fontFamily: "微软雅黑",
			fontSize: 13,
			fontWeight: 400,
			color: "#DAF4FF",
		},
	},
	grid: {
		top: "20%",
		right: "5%",
		left: "10%",
		bottom: "15%",
	},

	xAxis: [
		{
			type: "category",
			axisLabel: {
				color: "#DAF4FF",
				interval: 0,
				rotate: 45,
			},
			axisLine: {
				show: false,
				lineStyle: {
					color: "#0a3e98",
				},
			},
			axisTick: {
				show: false,
			},
			splitLine: {
				show: false,
				lineStyle: {
					color: "#195384",
					type: "dotted",
				},
			},
			data: [],
		},
	],
	yAxis: [
		{
			type: "value",
			name: "单位比率",
			min: 0,
			position: "left",
			nameTextStyle: {
				color: "#DAF4FF",
				fontSize: 11,
			},
			axisLine: {
				lineStyle: {
					color: "#464849",
				},
			},
			axisTick: {
				show: false,
			},
			splitLine: {
				show: false,
				lineStyle: {
					color: "#0a3e98",
					type: "dotted",
				},
			},
			// max: 100,
			// splitNumber: 5,
			axisLabel: {
				// formatter: "{value}%",
				formatter: function (i) {
					return i + '%';
				},
				textStyle: {
					color: "#DAF4FF",
				},
			},
		},

	],
	// dataZoom: [
	// 	{
	// 		show: true,
	// 		realtime: true,
	// 		start: 0,
	// 		end: 60,
	// 	},
	// 	{
	// 		type: "inside",
	// 		realtime: true,
	// 		start: 0,
	// 		end: 30,
	// 	},
	// ],
	series: [
		{
			data: [],
			// label: {
			// 	show: true,
			// 	formatter: '{b}\n{c}%'　　　　//这是关键，在需要的地方加上就行了
			// }
		}
	]
};
// 消防评估汇总圆饼图
export const firePieOption = {
	//柱形图和圆饼图相互切换
	toolbox: {
		show: true,
		feature: {
			myTool1: {
				show: true,
				title: "切换成柱状图",
				icon:
					"path://M96 416h832c0.32 0 0.576-0.192 0.896-0.192a30.656 30.656 0 0 0 30.976-30.976c-0.064-0.256 0.128-0.512 0.128-0.832a31.424 31.424 0 0 0-14.912-26.368l-188.48-188.48a30.72 30.72 0 1 0-43.456 43.456L852.544 352H96a32 32 0 0 0 0 64z m832 192H96c-0.32 0-0.576 0.192-0.896 0.192a30.528 30.528 0 0 0-30.976 30.976c0.064 0.256-0.128 0.512-0.128 0.832 0 11.264 6.144 20.672 14.912 26.368l188.48 188.48a30.72 30.72 0 1 0 43.456-43.456L171.456 672H928a32 32 0 0 0 0-64z",
				onclick: function () {

				},
			},


		},
		top: '20%'
	},
	title: [
		{
			text: "青岛消防评估汇总图",
			// left: "0%",
			top: "0%",
			left: "center",
			textStyle: {
				color: "#fff",
				fontSize: 14,
			},
		},
	],
	legend: {
		top: "16%", //通过这个数值调整图例的堆叠
		left: "0",
		orient: "vertical",
		textStyle: {
			color: "#fff",
			fontSize: 12,
		},
	},
	// backgroundColor: "#00333a", ////开发的时候注释掉
	tooltip: {
		trigger: "item",
	},
	series: [
		{
			type: "pie",
			// color: ["#358172", "#2b8a79", "#45a693", "#72b8a8", "#9cc8bd", "#c3dcd6"],
			radius: "70%",
			top: "0%",
			left: "40%",
			data: [],
			label: {
				normal: {
					show: false,
					position: "inside",
					formatter: "{value|{c}%}",
					rich: {
						value: {
							fontSize: 20,
							color: "#ffffff",
						},
					},
				},
			},
		},
	],
};
// 消防评估汇总柱状图
export const firePieOption1 = {
	toolbox: {
		show: true,
		feature: {
			myTool1: {
				show: true,
				title: "切换成圆饼图",
				icon:
					"path://M96 416h832c0.32 0 0.576-0.192 0.896-0.192a30.656 30.656 0 0 0 30.976-30.976c-0.064-0.256 0.128-0.512 0.128-0.832a31.424 31.424 0 0 0-14.912-26.368l-188.48-188.48a30.72 30.72 0 1 0-43.456 43.456L852.544 352H96a32 32 0 0 0 0 64z m832 192H96c-0.32 0-0.576 0.192-0.896 0.192a30.528 30.528 0 0 0-30.976 30.976c0.064 0.256-0.128 0.512-0.128 0.832 0 11.264 6.144 20.672 14.912 26.368l188.48 188.48a30.72 30.72 0 1 0 43.456-43.456L171.456 672H928a32 32 0 0 0 0-64z",
				onclick: function () {

				},
			},


		},
		top: '20%'
	},
	tooltip: {
		trigger: "axis",
		axisPointer: {
			type: "shadow",
		},
		// formatter:'{c}%'
	},
	xAxis: {
		type: 'category',
		axisLabel: {
			color: "#DAF4FF",
			interval: 0,
			rotate: 20,
		},
		axisTick: {
			show: false,
		},
		data: ['建筑防火失分', '建筑防火得分', '消防设施失分', '消防设施得分', '消防安全管理失分', '消防安全管理得分']
	},
	yAxis: {
		type: 'value',
		axisLabel: {
			color: "#DAF4FF",
			interval: 0,
		},
		axisTick: {
			show: false,
		},
	},
	series: [
		{
			data: [120, 200, 150, 80, 70, 110, 130],
			type: 'bar',
			itemStyle: {
				normal: {
					color: function (params) {
						// build a color map as your need.
						var colorList = ["#779875", "#4F7E44", "#AD8D7F", "#A75D33", "#5772A6", "#31559A"];
						return colorList[params.dataIndex]
					}
				}
			}
		}
	]

};
// 物联设备检测
export const equipmentOption = {
	tooltip: {
		trigger: "axis",
	},
	color: ["#fac858", "#ee6666", "#73c0de"],
	legend: {
		// data: ["高危", "中危", "其他"],
		itemGap: 10,
		// itemWidth: 15,
		itemHeight: 12,
		textStyle: { color: "#fff" },
	},

	xAxis: [
		{
			name: "",
			type: "category",
			axisTick: {
				show: false,
				alignWithLabel: false,
			},
			axisLabel: {
				textStyle: {
					color: "#e0e6f1",
				},
				rotate: 30,
			},
			data: [],
		},
	],
	yAxis: [
		{
			type: "value",
			// name: "数量",
			// minInterval: 1,
			axisLabel: {
				textStyle: {
					color: "#e0e6f1",
				},
			},
			splitLine: {
				show: true, // 分割线
			},
		},
	],
	series: [
		{
			data: [],
			name: "平台离线设备",
			stack: "one",
			type: "bar",
			barWidth: 10,
			// label: {
			// 	show: true,
			// },
		},
		{
			data: [],
			name: "平台在线设备",
			stack: "one",
			type: "bar",
			barWidth: 10,
			// label: {
			// 	show: true,
			// },
		},
		{
			data: [],
			name: "区域设备应有总数",
			// stack: "one",
			type: "bar",
			barWidth: 10,
			// label: {
			// 	show: true,
			// },
		},
	],
	dataZoom: [
		{
			orient: "horizontal",
			show: true,//控制滚动条显示隐藏
			realtime: true, //拖动滚动条时是否动态的更新图表数据
			height: 8, //滚动条高度
			start: 0, //滚动条开始位置（共100等份）
			end: 30,//滚动条结束位置
			bottom: "0%",
			// zoomLock: true, //控制面板是否进行缩放
			handleSize: 0,//滑动条的 左右2个滑动条的大小
			showDataShadow: false,//是否显示数据阴影 默认auto
			showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
			borderRadius: 5,
			fillerColor: '#269cdb',
			backgroundColor: '#fff',//两边未选中的滑动条区域的颜色
			borderColor: "#000",
		},
		{
			type: 'inside',
			brushSelect: true,
			start: 0,
			end: 100,
			xAxisIndex: [0],
		}

	],
};
